import { DatePipe } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { SuccessStoryService } from '../../../services/success-story.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SuccessStories, SuccessStory } from '@app/store/stories/state';
import { Observable } from 'rxjs';
import {
  selectIsDeleted,
  selectIsLoadingStoriesSuccessStory,
  selectIsLoadingSuccessStory,
  selectSuccessStoryById,
} from '@app/store/stories/selector';
import { Store } from '@ngrx/store';
import {
  deleteSuccessStory,
  getSuccessStoryById,
} from '@app/store/stories/actions';
import { UdfDialogComponent } from '@app/components/common/udf-dialog/udf-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CanEditService } from '@app/services/can-edit.service';

@Component({
  selector: 'app-success-story-details-page',
  templateUrl: './success-story-details-page.component.html',
  styleUrls: ['./success-story-details-page.component.scss'],
})
export class SuccessStoryDetailsPageComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  id: any;
  data: any;
  story: SuccessStory & { postDate?: Date; modifiedDate?: Date | null };
  contentImages: any;
  coverimage: any;

  showbutton: boolean = false;
  addsuccessstoryForm: SuccessStory = {
    title: '',
    short_description: '',
    solutions: '',
    cover_image: '',
    content_images: [],
    benefits_results: '',
    business_challenges: '',
    post_date: '',
    video: '',
  };
  pageTitleArea: pageTitle[] = [];
  video: any;
  isLoading$: Observable<boolean>;
  clickedDelete: boolean;

  constructor(
    private route: ActivatedRoute,
    private successStoryService: SuccessStoryService,
    private router: Router,
    private _snackBar: MatSnackBar,
    public datepipe: DatePipe,
    private store: Store<{ successStories: SuccessStories }>,
    public dialog: MatDialog,
    public canEditService: CanEditService
  ) {}

  get postDate(): Date {
    console.log(this.story?.post_date);
    return new Date(this.story?.post_date);
  }

  get modifiedDate(): Date | null {
    console.log(
      this.story?.modified_by ? new Date(this.story?.last_modified_date) : null
    );
    return this.story?.modified_by
      ? new Date(this.story?.last_modified_date)
      : null;
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.params.story;
    this.isLoading$ = this.store.select(selectIsLoadingSuccessStory);
    this.store.dispatch(getSuccessStoryById({ id: this.id }));
    this.store
      .select(selectSuccessStoryById)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: res => {
          const userName = this.successStoryService.userName();

          if (res?.post_by?.displayName == userName.displayName) {
            this.showbutton = true;
          } else if (
            this.canEditService.canEditTeam.includes(userName?.displayName)
          ) {
            this.showbutton = true;
          } else {
            this.showbutton = false;
          }
          if (res) {
            const { cover_image, content_images, video, ...rest } = res;

            this.coverimage = res?.cover_image;
            this.contentImages = res?.content_images;
            this.video = res?.video;
            res.post_date = res?.post_date.replace(/"/g, '');
            let currentDateTime = this.datepipe.transform(
              res.post_date,
              'MM-dd-yyyy'
            );
            res.post_date = currentDateTime;
            res.last_modified_date = res?.post_date.replace(/"/g, '');
            let currentModifiedDate = this.datepipe.transform(
              res.last_modified_date,
              'MM-dd-yyyy'
            );

            res.last_modified_date = currentModifiedDate;
            this.story = {
              ...rest,
              post_date: currentDateTime,
              last_modified_date: currentModifiedDate,
              cover_image: '',
              content_images: [],
              video: '',
            };
          }
          this.pageTitleArea = [
            {
              title: 'Success Stories',
              subTitle: this.story?.title,
            },
          ];
        },
      });

    this.store
      .select(selectIsDeleted)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(isDeleted => {
        if (isDeleted && this.clickedDelete) {
          this._snackBar.open(
            'Success Story Deleted Successfully.',
            'Dismiss',
            {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'right',
            }
          );
          this.router.navigate([`/success-stories`]);
        }
      });
  }

  openDialog(
    title: string,
    content: string,
    confirmLabel: string = 'Confirm',
    rejectLabel: string = 'Cancel'
  ): void {
    this.dialog
      .open(UdfDialogComponent, {
        width: '500px',
        data: {
          title,
          content,
          rejectLabel,
          confirmLabel,
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.clickedDelete = true;
          this.store.dispatch(deleteSuccessStory({ id: this.id }));
        }
      });
  }

  deleteData(id: number) {
    this.openDialog(
      `Please confirm deletion`,
      `Would you like to delete ${this.story.title}`
    );
  }
}
class pageTitle {
  title: string;
  subTitle: string;
}
